import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../core/store/store";
import BillingPlan from "./billing-plan";
import getBillingProcessor, { isSubscriptionCurrentlyActive } from "./get-billing-processor";
import PaykickstartEmbed from "./paykickstart-embed";

type Props = {
  open: boolean;
  onClose: () => void;
  processor?: string | null;
};

const BILLING_EMAIL = "support@wordform.ai";

export const NoCreditsLeftDialog = (props: Props) => {
  const { open = false, onClose, processor, ...other } = props;
  const authState = useSelector((state: RootState) => state.auth);
  const billingProcessor = processor ?? getBillingProcessor(authState.subscriptions, authState.user?.processor);
  const hasActivePaidSubscription = authState.subscriptions?.subscriptions?.some(
    (subscription) => isSubscriptionCurrentlyActive(subscription)
  );

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={onClose}
      open={open}
    //   }}
    >
      <DialogTitle>Oops... You Are Out of Credits!</DialogTitle>
      <DialogContent>
        Hello, according to our records, you no longer have any more credits
        available. Have questions? You can contact our billing department at:{" "}
        <b>{BILLING_EMAIL} </b>.
        {hasActivePaidSubscription ? (
          <>
            {" "}Or you can purchase more credits below.
            <Stack sx={{ p: 2 }}>
              {billingProcessor === "paykickstart" && <PaykickstartEmbed />}
              {billingProcessor !== "paykickstart" && <BillingPlan />}
            </Stack>
          </>
        ) : (
          <Stack sx={{ p: 2 }}>
            <Button href="https://wordform.ai/evergreen/" target="_blank" variant="contained">
              View Pricing
            </Button>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
